import { pageId } from "utils/pageId";

class DashboardPageIds {
    root = pageId("Dashboard");
    configure = pageId("Dashboard.Configure", "Configure Dashboard");
}

export default new DashboardPageIds();
